export const RegisterGuestContent = {
  // Page title
  pageTitle: 'Add Guest',
  pageDisclaimer:
    'Please note that you are responsible for all guests and their actions while they are at the office.',

  // Form fields
  firstName: 'First Name',
  firstNamePlaceholder: 'Enter first name',
  lastName: 'Last Name',
  lastNamePlaceholder: 'Enter last name',
  email: 'Email',
  emailPlaceholder: 'Enter email address',
  visitDate: 'Date of Visit',
  visitDatePlaceholder: 'Select date',
  reasonForVisit: 'Reason for Visit',
  reasonForVisitPlaceholder: 'Enter reason for visit',
  acknowledgment: 'I understand guests must be accompanied at all times',
  acknowledgmentRequired: 'You must acknowledge responsibility for your guests',

  // Buttons
  submit: 'Register Guest',
  cancel: 'Cancel',
  done: 'Done',

  // Success message
  successTitle: 'Guest Registered!',
  successMessage: 'The guest has been successfully registered.',

  // Error messages
  errorTitle: 'Registration Failed',
  errorMessage: 'Failed to register guest. Please try again.',
};


